import { RECRUITER_PATH } from '../../utilities/devex_paths';
const DEFAULT_PAGE_SIZE = 20;
const FEATURED_JOBS_PAGE_SIZE = 5;
const JOB_POSTING_OPTIONS_PATH = '/jobs/posting-options';
const MY_POSTED_JOBS = `${RECRUITER_PATH}/jobs/posted_by_me`;
const MY_SAVED_JOBS = '/my-jobs';
const RECRUITER_DASHBOARD_MY_POSTED_JOBS = `${RECRUITER_PATH}/posted_jobs/posted_by_me`;

const PUBLICATION_INTERVAL_OPTIONS: { text: string; value: string }[] = [
  { text: 'Last 24h', value: '24h' },
  { text: 'Last week', value: 'week' },
];

const newsTopicValues: string[] = [
  'Global Health',
  'Project Management',
  'Democracy, Human Rights & Governance',
  'Agriculture & Rural Development',
  'Humanitarian Aid',
  'Economic Development',
  'Social/Inclusive Development',
  'Environment & Natural Resources',
  'Finance & Banking',
  'Careers & Education',
  'Research',
  'Institutional Development',
  'Private Sector',
  'Media And Communications',
  'Water & Sanitation',
  'Innovation & ICT',
  'Energy',
  'Urban Development',
  'Infrastructure',
  'Trade & Policy',
  'Funding',
];

const NEWS_TOPIC_OPTIONS: { text: string; value: string }[] = newsTopicValues.map((topic) => ({
  text: topic,
  value: topic === 'Finance & Banking' ? 'Banking & Finance' : topic,
}));

export {
  DEFAULT_PAGE_SIZE,
  FEATURED_JOBS_PAGE_SIZE,
  JOB_POSTING_OPTIONS_PATH,
  PUBLICATION_INTERVAL_OPTIONS,
  NEWS_TOPIC_OPTIONS,
  MY_POSTED_JOBS,
  MY_SAVED_JOBS,
  RECRUITER_DASHBOARD_MY_POSTED_JOBS,
};
